import { createContext, useContext } from 'react';
import type { CollectionEntry, FieldDefinition } from '../types/cms';

interface Collection {
  id: string;
  name: string;
  slug: string;
  fieldsJson: FieldDefinition[];
}

interface EntryContextValue {
  entry: CollectionEntry;
  collection: Collection;
}

export const EntryContext = createContext<EntryContextValue | null>(null);

export function useEntryContext(): EntryContextValue {
  const ctx = useContext(EntryContext);
  if (!ctx) throw new Error('useEntryContext must be used within EntryContextProvider');
  return ctx;
}

export function EntryContextProvider({
  entry,
  collection,
  children,
}: {
  entry: CollectionEntry;
  collection: Collection;
  children: React.ReactNode;
}) {
  return <EntryContext.Provider value={{ entry, collection }}>{children}</EntryContext.Provider>;
}
